import { readWeb3Address } from '#shared/utils/web3Address'

/**
 * A Supabase session alone is not "signed in": the wallet connected now must be the one
 * the session was signed with, because a stale session outlives a disconnected wallet.
 */
export function isSignedInWithWallet(
  user: { sub?: string, app_metadata?: unknown } | null | undefined,
  connectedAddress: string | null | undefined,
): boolean {
  const sessionAddress = readWeb3Address(user?.app_metadata)
  return user?.sub != null
    && user.sub !== ''
    && connectedAddress != null
    && sessionAddress != null
    && connectedAddress.toLowerCase() === sessionAddress.toLowerCase()
}
